import React, { useEffect, useState } from 'react';
import About from './components/about/About';
import Header from './components/header/Header';
import Intro from './components/Intro/Intro';
import { Helmet } from 'react-helmet-async';
import Skill from './components/Skill/Skills';
import 'aos/dist/aos.css';
import Contact from './components/contact/Contact';
import Projects from './components/projects/Projects';
import Aos from 'aos';
import fade from './Fade';
const App = () => {
  const hash = window.location.hash.slice(1).split('_').join(' ')
  console.log(hash)

  useEffect(() => {
    Aos.init({
      duration: 2000
    });
  }, []);
  return (
    <div data-theme='dark' style={{ height: '100vh', overflow: 'auto' }} >
      <Helmet>
        <title>MD RAKIBUL ISLAM || {hash}</title>
      </Helmet>
      <Header />
      <Intro />
      <Skill />
      <Projects />
      <About />
      <Contact />
    </div>

  );
};

export default App;